module.exports = __webpack_public_path__ + "static/media/JOY.96341c75.svg";